const API_BASE = '/api';

export async function planTrip(request: {
  origin: { lat: number; lon: number };
  destination: { lat: number; lon: number };
  date: string;
  time: string;
  arriveBy?: boolean;
  mode?: string;
  maxResults?: number;
  maxTransfers?: number;
  bikeTransferWeight?: number;
  bikeSafety?: string;
}) {
  const res = await fetch(`${API_BASE}/plan`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `API error ${res.status}`);
  }
  return res.json();
}

export async function fetchStops(lat: number, lon: number, radius = 1500) {
  const res = await fetch(`${API_BASE}/stops?lat=${lat}&lon=${lon}&radius=${radius}`);
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export async function fetchDepartures(stopId: string, timeRange = 3600, numberOfDepartures = 20) {
  const res = await fetch(`${API_BASE}/departures?stopId=${encodeURIComponent(stopId)}&timeRange=${timeRange}&numberOfDepartures=${numberOfDepartures}`);
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export async function checkHealth() {
  const res = await fetch(`${API_BASE}/health`);
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export async function reverseGeocode(lat: number, lon: number): Promise<string | null> {
  const res = await fetch(`${API_BASE}/geocode/reverse?lat=${lat}&lon=${lon}`);
  if (!res.ok) return null;
  const data = await res.json();
  return data.display_name || null;
}

export async function geocode(query: string, limit = 8, near: { lat: number; lon: number } | null = null) {
  if (!query || query.trim().length < 3) return [];
  const params = new URLSearchParams({ q: query, limit: String(limit) });
  if (near) {
    params.set('lat', String(near.lat));
    params.set('lon', String(near.lon));
  }
  const res = await fetch(`${API_BASE}/geocode?${params}`);
  if (!res.ok) return [];
  return res.json();
}
